import { useTranslation } from 'react-i18next';
import { ListChecks } from 'lucide-react';
import { useMyOpenTasks } from '@/api/queries/useMyOpenTasks';
import { OpenTasksTable } from '@/components/tasks/OpenTasksTable';
import { ApprovalsSection } from '@/components/approvals/ApprovalsSection';
import { PartnerErrorState } from '@/pages/partner/components/PartnerErrorState';
import { PartnerPageHeader } from '@/pages/partner/components/PartnerPageHeader';

/**
 * The partner "Aufgaben" page: the generic open-tasks table in the partner
 * frame. A partner tenant has no process work, so none of the other
 * "Meine Aufgaben" blocks apply here.
 */
export function PartnerTasksPage() {
  const { t } = useTranslation();
  const { data, isLoading, isError, isFetching, error, refetch } = useMyOpenTasks();

  return (
    <div className="flex h-full flex-col">
      <div className="flex min-h-0 flex-1 flex-col gap-6 p-6">
        <PartnerPageHeader
          title={t('partner.tasks.title')}
          subtitle={t('partner.tasks.subtitle')}
          onRefresh={() => refetch()}
          isRefreshing={isFetching}
        />

        {isError ? (
          <PartnerErrorState
            error={error}
            icon={ListChecks}
            title={t('partner.common.loadError')}
            onRetry={() => refetch()}
          />
        ) : (
          <OpenTasksTable tasks={data ?? []} isLoading={isLoading} />
        )}
        <ApprovalsSection />
      </div>
    </div>
  );
}
